import React from 'react';
import { diffLines, Change } from 'diff';

type DiffViewerProps = {
  firstData: string;
  secondData: string;
  className?: string;
};

export const DiffViewer: React.FC<DiffViewerProps> = ({ firstData, secondData, className }) => {
  const diff = diffLines(firstData, secondData);
  return (
    <pre
      className={`text-sm font-mono bg-slate-50 text-white p-4 rounded-md overflow-auto border border-dashed border-slate-300 ${className}`}
    >
      {diff.map((part: Change, index: number) => {
        const background = part.added
          ? 'bg-[#c0f3cb] text-slate-800'
          : part.removed
            ? 'bg-[#efa39e]'
            : 'bg-slate-300';
        const prefix = part.added ? '+' : part.removed ? '-' : ' ';
        return (
          <div key={index} className={`${background} px-2 whitespace-pre-wrap`}>
            {part.value.split('\n').map((line, i) =>
              line ? (
                <div key={i}>
                  <span className="text-gray-400">{prefix}</span>
                  {line}
                </div>
              ) : null
            )}
          </div>
        );
      })}
    </pre>
  );
};
